import React from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { formatDate } from '../../assets/info/Posts';
import { plain } from '../RichText';
import styles from './PostList.module.scss';

// Index for one writing collection. `basePath` is the route the posts live
// under, e.g. '/technical'.
export default function PostList({ posts, basePath, empty }) {
  return (
    <Box component={'main'} className={styles.list}>
      {posts.length === 0 ? (
        <p className={styles.empty}>{empty || 'Nothing here yet — check back soon.'}</p>
      ) : (
        <Box>
          {posts.map((post) => (
            <Link key={post.slug} to={`${basePath}/${post.slug}`} className={styles.row}>
              <Box className={styles.rowLeft}>
                <h3 className={styles.title}>{plain(post.title)}</h3>
                <p className={styles.excerpt}>{plain(post.excerpt)}</p>
                {post.tags && (
                  <Box className={styles.tags}>
                    {post.tags.map((tag) => (
                      <span key={tag}>{tag}</span>
                    ))}
                  </Box>
                )}
              </Box>
              <Box className={styles.rowRight}>
                <span className={styles.date}>{formatDate(post.date)}</span>
                {post.readTime && <span className={styles.readTime}>{post.readTime} read</span>}
              </Box>
            </Link>
          ))}
        </Box>
      )}
    </Box>
  );
}
